import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import {
  CapacityGranularity,
  CapacitySort,
  Filter,
  ResourceOccupancy,
} from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestPending: boolean;
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  content: ResourceOccupancy[];
  currentPage: number;
  canLoadMore: boolean;
  totalElements: number;
  retrieveOccupancy(request: Boundaries["retrieveOccupancy"]["request"]): void;
}

function useRetrieveOccupancy(
  from: string,
  to: string,
  granularity: CapacityGranularity,
  filter: Filter | undefined,
  sort: CapacitySort | undefined,
  size: number,
): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(() =>
      selector.isRetrieveOccupancyRequestPending(
        from,
        to,
        granularity,
        filter,
        sort,
        size,
      ),
    ),
    isRequestSuccess: useSelector(() =>
      selector.isRetrieveOccupancyRequestSuccess(
        from,
        to,
        granularity,
        filter,
        sort,
        size,
      ),
    ),
    isRequestFailure: useSelector(() =>
      selector.isRetrieveOccupancyRequestFailure(
        from,
        to,
        granularity,
        filter,
        sort,
        size,
      ),
    ),
    content: useSelector(() =>
      selector.getOccupancyContent(from, to, granularity, filter, sort, size),
    ),
    currentPage: useSelector(() =>
      selector.getOccupancyCurrentPage(
        from,
        to,
        granularity,
        filter,
        sort,
        size,
      ),
    ),
    canLoadMore: useSelector(() =>
      selector.canLoadMoreOccupancy(from, to, granularity, filter, sort, size),
    ),
    totalElements: useSelector(() =>
      selector.getOccupancyTotalElements(
        from,
        to,
        granularity,
        filter,
        sort,
        size,
      ),
    ),
    retrieveOccupancy: core.retrieveOccupancy,
  };
}

export { useRetrieveOccupancy };
